module.exports = __webpack_public_path__ + "static/media/profile.0ece2349.jpg";